import React, { useRef, useState } from 'react';
import { AnnounceComponent, IframeContainer, UploadBTN } from './Component';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import ReactPlayer from 'react-player';
const Video = (props: any) => {
  const [type, settype] = useState(props.videoLink ? 2 : 0);
  const TypeSelection = [{ label: 'Link', value: 1 }];
  const inputFile: any = useRef(null);
  const maxfileSize: any = localStorage.getItem('one_video_size_max');
  const ext = ['mp4', 'mov'];


  const [vidUrl, setVidUrl] = useState(props.videoLink
    ? `${process.env.REACT_APP_AWS_STORAGE + props.videoLink}`
    : '');

  const browseVideoFile = (e: any) => {
    const exten = e.target.files[0]?.name.split('.').pop()
    if (e.target.files[0]?.size > (maxfileSize * 1024 * 1024)) {
      toast.error(
        `Maximum Video size should be ${maxfileSize} MB. `,
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    } else if (!ext.includes(exten)) {
      toast.error(`Please enter a valid Video type`, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      props.setvideo(e.target.files[0] ? e.target.files[0] : '');
      setVidUrl(URL.createObjectURL(e.target.files[0]))
    }
  };
  useEffect(() => {
    settype(props.videoLink ? 1 : 0);
  }, [props.videoLink]);

  return (
    <>
      <AnnounceComponent className="p-pt-2">
        {true && (
          <div className="p-grid">
            <div className="p-col-3 p-m-2">
              <UploadBTN
                type="button"
                onClick={() => {
                  inputFile.current.click();
                }}
              >
                Upload
                <input
                  autoFocus
                  multiple={false}
                  hidden
                  type="file"
                  ref={inputFile}
                  accept="video/mp4, .mov"
                  onChange={(e) => {
                    browseVideoFile(e);
                    props.setVideoLink(null);
                    e.target.value = '';
                  }}
                />
              </UploadBTN>
            </div>

            <IframeContainer className="p-col-6 p-mt-xl-6 p-mt-md-6">
              <ReactPlayer
                className='react-player'
                // url= 'M_03292018202006_00000000U2940605_1_001-1.MP4'
                url={vidUrl}
                width='100%'
                height='100%'
                controls={true}
                style={{ maxHeight: '40vh', borderRadius: '15px', maxWidth: '100vh', overflow: 'hidden' }}

              />
            </IframeContainer>
          </div>
        )}
      </AnnounceComponent>
      <div className='w-100 p-pt-2' style={{width:'100%'}}>
        <p className='' style={{width:'fit-content', margin:'auto', filter:'opacity(0.5)'}}>only .mp4 and .mov videos are acceptable</p>
      </div>
    </>

  );
};

export default Video;
